<template>
  <WdsStack align-center gap-sm>
    {{ title }}
    <div v-show="hasErrors" class="tw-bg-red-500 tw-rounded-full tw-h-1 tw-w-1"></div>
  </WdsStack>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsStack } from '@worksome/wds-components'

import { JOB_TAB } from '@/components/Job/constants'
import { useValidationStore } from '@/components/Job/Edit/store/useValidationStore'

const props = defineProps<{
  title: string
  tabKey: JOB_TAB
}>()

const validationStore = useValidationStore()

const hasErrors = computed(() => {
  const hasTabErrors = validationStore.customVuelidate.v$.$validationGroups[props.tabKey].$error

  if (props.tabKey === JOB_TAB.OVERVIEW) {
    return validationStore.hasErrors || hasTabErrors
  }

  return hasTabErrors
})
</script>
